var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272 260"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".asterisk_svg__cls-astriex1{isolation:isolate}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asterisk_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asterisk_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asterisk_svg___",
    className: "asterisk_svg__cls-astriex1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272 102v56l-91-3 52 75-51 30-46-81-46 81-51-30 52-75-91 3v-56l91 3-52-75L90 0l46 81 46-81 51 30-52 75z",
    fill: "#b75151"
  }))))));
}

export default SvgAsterisk;